import initializer from '@/lib/initializer'
import lazyModule from '@/lib/lazy-module'
import 'vite/modulepreload-polyfill'
import { initDisclosureWidgets } from '@/lib/a11y'
import revive from '@/lib/revive.js'
import { initTabKeyListener } from '@/lib/accessibility'
import { initBluecore } from '@/lib/bluecore'
import scrollAnimation from '@/lib/scroll-animation'
import sal from 'sal.js'

const islands = import.meta.glob('@/islands/**.js')
const summaries = document.querySelectorAll('[id^="Details-"] summary')

revive(islands)
initDisclosureWidgets(summaries)

if (window.decodeURI(window.location.pathname) === '/account/addresses') {
  import('@/lib/shopify_common')
  import('@/lib/customer-address')
}

import picture from '../../modules/picture/picture'
import productCardMixin from '../../modules/product-card/product-card-mixin'
import carouselSwiper from '../../modules/carousel-swiper/carousel-swiper'
import accordions from '../../modules/accordions/accordions'
import header from '../../modules/header/header'
import footer from '../../modules/footer/footer'
import promobar from '../../modules/promobar/promobar'
import productMain from '../../modules/product-main/product-main'
import featuredProduct from '../../modules/featured-product/featured-product'
import productCarousel from '../../modules/product-carousel/product-carousel'
import productForm from '../../modules/product-form/product-form'
import cartGrid from '../../modules/cart-grid/cart-grid'
import miniCart from '../../modules/mini-cart/mini-cart'
import benefits from '../../modules/benefits/benefits'
import marquee from '../../modules/marquee/marquee'
import bundleInfo from '../../modules/bundle-info/bundle-info'
import contentCarousel from '../../modules/content-carousel/content-carousel'
import addToBagButton from '../../modules/add-to-bag-button/add-to-bag-button'
import reviews from '../../modules/reviews/reviews'
import faqs from '../../modules/faqs/faqs'
import keyIngredients from '../../modules/key-ingredients/key-ingredients'
import brandCarousel from '../../modules/brand-carousel/brand-carousel'
import highlightBar from '../../modules/highlight-bar/highlight-bar'
import routine from '../../modules/routine/routine'
import results from '../../modules/results/results'
import testimonials from '../../modules/testimonials/testimonials'
const newsletterForm = lazyModule('newsletterForm', { offset: 120 })

document.addEventListener('DOMContentLoaded', () => {
  initializer({
    picture,
    productCardMixin,
    carouselSwiper,
    accordions,
    promobar,
    header,
    productMain,
    productForm,
    featuredProduct,
    productCarousel,
    cartGrid,
    miniCart,
    footer,
    benefits,
    bundleInfo,
    addToBagButton,
    contentCarousel,
    faqs,
    reviews,
    keyIngredients,
    marquee,
    brandCarousel,
    newsletterForm,
    highlightBar,
    routine,
    results,
    testimonials
  })

  initTabKeyListener()
  scrollAnimation()
  initBluecore()
  // Do not remove "window.scrollAnimations" because it's currently used in multiple places
  window.scrollAnimations = sal({
    threshold: 0.1,
  })
})